class ProductActionDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector(`#ProductActionDrawerOverlay`).addEventListener('click', this.close.bind(this));

        this.forms = this.querySelectorAll('product-form');

        this.triggerButtons = document.querySelectorAll('button[data-product-action-open]');
        this.triggerButtons.forEach((button) => this.setAccessibility(button));

        this.inputChecked = null;
        this.initInputEvents();
    }

    handleSubmitButtonClick(evt) {
        if (!evt.currentTarget.getAttribute('disabled')) window.currentDrawer = this;
    }

    initInputEvents() {
        for (const form of this.forms) {
            const submitButton = form.querySelector('button[type="submit"]');
            const recommendations = form.querySelector('.product-recommendations:not(.no-variant)');
            submitButton.addEventListener('click', this.handleSubmitButtonClick.bind(this));
            const inputs = form.querySelectorAll('input');
            for (const input of inputs) {
                input.addEventListener('click', () => {
                    const inputId = input.getAttribute('id');
                    const sellingPlan = input.dataset.sellingPlan;
                    const sellingPlanInput = sellingPlan ? form.querySelector('.' + sellingPlan) : null;
                    const elmId = input.getAttribute('id');
                    if (sellingPlanInput) {
                        sellingPlanInput.checked = true;
                        form.dataset.additionalBehavior = 'addSubscription';
                    } else {
                        form.dataset.additionalBehavior = '';
                    }

                    if (elmId && elmId.startsWith('Add')) {
                        form.dataset.additionalBehavior = 'addPack';
                    }

                    if (this.inputChecked === inputId) {
                        input.checked = false;
                        if (sellingPlanInput) {
                            sellingPlanInput.checked = false;
                        }
                        submitButton.setAttribute('disabled', 'true');
                        this.inputChecked = null;
                        recommendations?.classList.add('xhidden');
                        this.classList.remove('option-selected');
                        form.dataset.additionalBehavior = '';
                    } else {
                        submitButton.removeAttribute('disabled');
                        this.inputChecked = inputId;
                        recommendations?.classList.remove('xhidden');
                        this.classList.add('option-selected');
                    }
                });
            }

            const recommendedProducts = form.querySelectorAll('.product-recommended-drawer');
            for (const product of recommendedProducts) {
                product.addEventListener('click', (event) => {
                    event.preventDefault();
                    window.dontOpenCart = true;

                    if (!event.currentTarget.dataset.productId) {
                        window.callbackLocation = event.currentTarget.getAttribute('href');
                    } else {
                        window.currentDrawer = this;
                    }

                    submitButton.click();
                });
            }
        }
    }

    setAccessibility(button) {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(button);
        });
        button.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(button);
            }
        });
    }

    open(triggeredBy) {
        if (!triggeredBy) return;
        this.setActiveElement(triggeredBy);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });

        const productId = triggeredBy.dataset.productActionOpen;
        this.forms.forEach((form) => {
            if (form.dataset.productId === productId) form.classList.remove('xhidden');
            else form.classList.add('xhidden');
        });

        toggleBodyScroll(false);
        this.resetForms();

        this.addEventListener(
            'transitionend',
            () => {
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(document.getElementById('ProductActionDrawer'), focusElement);
            },
            { once: true }
        );
    }

    close() {
        this.classList.remove('active');
        this.resetForms();
        removeTrapFocus(this.activeElement);
        toggleBodyScroll(true);
    }

    resetForms() {
        this.classList.remove('option-selected');
        this.inputChecked = null;
        for (const form of this.forms) {
            const submitButton = form.querySelector('button[type="submit"]');
            if (!submitButton.dataset.noDisabled) {
                submitButton.setAttribute('disabled', 'true');
            }
            const inputs = form.querySelectorAll('input');
            for (const input of inputs) {
                input.checked = false;
            }

            const recommendations = form.querySelector('.product-recommendations:not(.no-variant)');
            recommendations?.classList.add('xhidden');
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('product-action-drawer', ProductActionDrawer);
